var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuild(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6309 4.9315L15.5309 4.87379C14.8274 4.46762 13.9251 4.7094 13.5189 5.41291L13.4376 5.55367C13.0315 6.25717 13.2733 7.15953 13.9768 7.5657L14.0767 7.6234C14.3414 7.77624 14.683 7.68472 14.8359 7.41999L15.8343 5.69065C15.9872 5.42593 15.8956 5.08433 15.6309 4.93149L15.6309 4.9315Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9197 3.83754C13.88 3.70115 13.7857 3.58245 13.6688 3.51979L10.5675 1.81571C9.54863 1.25466 8.30146 1.26016 7.31046 1.83093C6.41463 2.348 5.88013 3.06865 5.85815 3.09801L5.51402 3.56582L6.09188 3.60812C6.10438 3.60794 7.37313 3.70613 8.36536 4.279L8.86884 4.56968L6.44376 8.77003C5.94983 8.65514 5.41592 8.87012 5.14872 9.33293L2.81659 13.3723C2.48951 13.9388 2.68443 14.6658 3.25081 14.9928L4.38189 15.6459C4.94841 15.9729 5.67543 15.778 6.00243 15.2116L8.33468 11.1723C8.60189 10.7095 8.52007 10.1415 8.17464 9.76936L10.5988 5.57066L12.0205 6.39151C12.2704 6.53577 12.5916 6.44971 12.7359 6.19983L13.8667 4.24114C13.9402 4.11829 13.9584 3.97568 13.9198 3.83735L13.9197 3.83754Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuild);
export default __webpack_public_path__ + "static/media/build.519d4f026d4ea2d7ca5d4a90a77d5bf8.svg";
export { ForwardRef as ReactComponent };